import React, { useState, useRef } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const CONFIRM_TEXT = {
  refund: 'Вернуть деньги на карту? Это действие необратимо.',
  reopen: 'Открыть задание для новых исполнителей? Средства останутся в системе.',
  close: 'Закрыть задание? Денег на платформе по заданию от организации нет, возврат не требуется.',
};
const SUCCESS_TEXT = {
  refund: 'Возврат инициирован. Обычно занимает 1–5 рабочих дней.',
  reopen: 'Задание открыто для новых исполнителей.',
  close: 'Задание закрыто.',
};

export const DisputeCustomerChoiceBlock = ({ task, showToast, onTaskUpdate }) => {
  const [loading, setLoading] = useState(false);
  const inFlight = useRef(false);
  const isB2b = !!task?.is_b2b;

  const handleChoice = async (choice) => {
    if (inFlight.current) return;
    if (!window.confirm(CONFIRM_TEXT[choice])) return;
    inFlight.current = true;
    setLoading(true);
    try {
      const r = await axios.post(`${API}/tasks/${task.id}/customer-dispute-resolution`, { choice });
      showToast(r.data?.already_done ? 'Решение уже принято.' : SUCCESS_TEXT[choice], 'success');
      if (onTaskUpdate) onTaskUpdate();
    } catch (err) {
      showToast(err.response?.data?.detail || 'Ошибка при обработке запроса', 'error');
    } finally {
      inFlight.current = false;
      setLoading(false);
    }
  };

  return (
    <div className="reversia-card" style={{background: '#eff6ff', border: '1px solid #bfdbfe'}} data-testid="dispute-customer-choice-block">
      <h3 className="text-lg font-semibold mb-2" style={{color: '#1e40af'}}>Спор решён в вашу пользу</h3>
      <p className="text-sm mb-4" style={{color: '#1e3a8a'}}>
        {isB2b
          ? 'Администратор принял решение в вашу пользу. Расчёты по заданию от организации проходят вне платформы, поэтому возврат через платформу не предусмотрен. Выберите дальнейшее действие:'
          : 'Администратор принял решение в вашу пользу. Выберите дальнейшее действие:'}
      </p>
      <div className="flex flex-wrap gap-3">
        {isB2b ? (
          <button
            data-testid="dispute-close-btn"
            onClick={() => handleChoice('close')}
            disabled={loading}
            className="px-4 py-2 bg-slate-600 text-white rounded-md hover:bg-slate-700 disabled:opacity-50 text-sm font-medium"
          >
            Закрыть задание
          </button>
        ) : (
          <button
            data-testid="dispute-refund-btn"
            onClick={() => handleChoice('refund')}
            disabled={loading}
            className="px-4 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700 disabled:opacity-50 text-sm font-medium"
          >
            Вернуть деньги на карту
          </button>
        )}
        <button
          data-testid="dispute-reopen-btn"
          onClick={() => handleChoice('reopen')}
          disabled={loading}
          className="px-4 py-2 bg-teal-600 text-white rounded-md hover:bg-teal-700 disabled:opacity-50 text-sm font-medium"
        >
          Открыть для новых исполнителей
        </button>
      </div>
    </div>
  );
};
